export function createBlobFromResponse(data, contentType = 'application/octet-stream') {

    console.log('createBlobFromResponse', data, contentType);

    if (typeof data === 'string') {
        // Base64-encoded Data URL
        if (data.startsWith('data:')) {
            const [meta, base64Data] = data.split(',');
            if (!base64Data) {
                throw new Error('Malformed data URL: missing base64 content');
            }

            const mimeMatch = meta.match(/data:(.*);base64/);
            contentType = mimeMatch ? mimeMatch[1] : contentType;

            const byteString = atob(base64Data);
            const byteArray = new Uint8Array(byteString.length);
            for (let i = 0; i < byteString.length; i++) {
                byteArray[i] = byteString.charCodeAt(i);
            }

            return new Blob([byteArray], { type: contentType });
        }

        // Binary string (e.g. PDF streamed as string)
        const byteArray = new Uint8Array(data.length);
        for (let i = 0; i < data.length; i++) {
            byteArray[i] = data.charCodeAt(i) & 0xff;
        }

        return new Blob([byteArray], { type: contentType });
    }

    if (typeof Blob !== 'undefined' && data instanceof Blob) {
        return data;
    }

    if (data instanceof ArrayBuffer || data instanceof Uint8Array) {
        return new Blob([data], { type: contentType });
    }

    throw new Error("Unsupported data type for Blob creation.");
}
